module.exports = __webpack_public_path__ + "static/media/locket-photo-print-heart-shape.3b0b7901.jpg";